/* eslint-disable @typescript-eslint/naming-convention -- Many of the keys are used for CSV export */
import { AdmProject } from "@custom-types/base-types";
import { FaroCoreApiTypes, FaroCoreApiUtils } from "@stellar/core-api-client";
import { getMemberDisplayName } from "@utils/data-display";
import { isCompanyContext } from "@utils/type-guards";
import { CsvExportUtils, DateTimeUtils, UiUtils } from "@stellar/utils";

export const CSVDataUtils = {
  /**
   * Create csv file out of projects array and create a download handler
   */
  downloadProjectData(projects: AdmProject[]): void {
    const csvData = projects.map((project: AdmProject) => {
      return {
        ID: project.id,
        Name: project.name,
        Area: `${project.area.amount} ${project.area.unit}`,
        Address: project.address,
        State: project.state,
        URL: project.fileUrl,
        "Created At": DateTimeUtils.formatDateTimeInUtc({
          date: project.createdAt,
        }),
        "Modified At": DateTimeUtils.formatDateTimeInUtc({
          date: project.modifiedAt,
        }),
        Standalone: project.standalone,
        "Access Level": project.accessLevel,
        "Project Manager": getMemberDisplayName(project.projectManager),
        "Project Context": project.context.kind,
        "Workspace's Name": isCompanyContext(project.context)
          ? project.context.company.name
          : "-",
        "Group's Name": isCompanyContext(project.context)
          ? project.context.group.name
          : "-",
      };
    });

    CsvExportUtils.toFileDownload(csvData, "Projects List.csv");
  },

  /**
   * Create csv file out of group array and create a download handler
   */
  downloadGroupData(groups: FaroCoreApiTypes.AdmCompanyGroup[]): void {
    const csvData = groups.map((group: FaroCoreApiTypes.AdmCompanyGroup) => ({
      ID: group.id,
      Name: group.name,
      "Created At": DateTimeUtils.formatDateTimeInUtc({
        date: group.createdAt,
      }),
      "Sqft Assigned": group.sqft.assigned,
      "Sqft Used": group.sqft.used,
      "Thumbnail Url": group.thumbnailUrl,
    }));

    CsvExportUtils.toFileDownload(csvData, "Groups List.csv");
  },

  /** Create csv file out of member array and create a download handler */
  downloadMemberData(
    members: FaroCoreApiTypes.AdmCompanyMemberWithAuth[]
  ): void {
    const csvData = members.map((member) => ({
      ID: member.identity,
      Name: getMemberDisplayName(member),
      Email: member.email,
      status: FaroCoreApiUtils.Member.isTeam(member)
        ? UiUtils.DASH
        : FaroCoreApiUtils.Member.getMemberStatus(member),
      role: FaroCoreApiUtils.Workspace.formatUserWorkspaceRole(member.role),
      "Thumbnail Url": member.thumbnailUrl,
    }));

    CsvExportUtils.toFileDownload(csvData, "Members List.csv");
  },
};
